// extracted by mini-css-extract-plugin
export default {"noeventscontainer":"Trending_noeventscontainer__r3i8J","noeventsimage":"Trending_noeventsimage__SAYtQ","noeventsbutton":"Trending_noeventsbutton__Co8Fw"};